import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { curveCardinal } from 'd3-shape';

@Component({
    selector: 'app-conv-voice-chart',
    templateUrl: './conv-voice-chart.component.html',
    styleUrl: './conv-voice-chart.component.scss',
    standalone: false
})
export class ConvVoiceChartComponent {
	@Input() voiceData: any[] = [];
	@Input() voicePitchData: any[] = [];
	@Input() voiceSegmentData: any[] = [];

	chartData: any[] = [
		{ name: 'Voice', series: [] },
		{ name: 'Pitch', series: [] },
		{ name: 'Segment', series: [] }
	];

	voiceChartData: any[] = [
		{ name: 'Voice', series: [] },
		{ name: 'Pitch', series: [] }
	];

	segmentsChartData: any[] = [
		{ name: 'Segment', series: [] }
	];

	curve: any = curveCardinal;

	legend = false;
  animations = false;
  autoScale = false;
  showGridLines = true;
  roundDomains = false;
  xAxis = true;
  yAxis = true;
  showYAxisLabel = true;
  showXAxisLabel = true;
	min = 0;
	max = 1;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#15A607', '#F1D50A'],
  };

	colorScheme2: string | Color = {
		name: 'myScheme',
		selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#0AB5F1'],
  };

	ready = false;

	lastVoice = 0;
	lastPitch = 0;
	lastSegment = 0;

	calculateChartData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart: any = [
			{ name: 'Voice', series: [] },
			{ name: 'Pitch', series: [] },
			{ name: 'Segment', series: [] }
		];

		const voiceDataChart: any = [
			{ name: 'Voice', series: [] },
			{ name: 'Pitch', series: [] }
		];

		const segmentsDataChart: any = [
			{ name: 'Segment', series: [] }
		];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let voice;
			let pitch;
			let segment;

			if (index < this.voiceData.length) {
				voice = +(this.voiceData[index].value).toFixed(2);
				this.lastVoice = voice;
			} else {
				voice = this.lastVoice;
			}

			if (index < this.voicePitchData.length) {
				pitch = +(this.voicePitchData[index].value).toFixed(2);
				this.lastPitch = pitch;
			} else {
				pitch = this.lastPitch;
			}

			if (index < this.voiceSegmentData.length) {
				segment = +(this.voiceSegmentData[index].value).toFixed(2);
				this.lastSegment = segment;
			} else {
				segment = this.lastSegment;
			}

			voiceDataChart[0].series.push({ name: time, value: voice });
			voiceDataChart[1].series.push({ name: time, value: pitch });
			segmentsDataChart[0].series.push({ name: time, value: segment });

			dataChart[0].series.push({ name: time, value: voice });
			dataChart[1].series.push({ name: time, value: pitch });
			dataChart[2].series.push({ name: time, value: segment });
		}

		this.chartData = [...dataChart];
		this.voiceChartData = [...voiceDataChart];
		this.segmentsChartData = [...segmentsDataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

	updateChart(currentTime: number) {
		if (currentTime > 20) {
			this.calculateChartData(currentTime);
		} else {
			this.calculateChartData(20);
		}
	}

	showChart() {
		this.ready = true;
		this.calculateChartData(20);
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
